import { useEffect,useState } from "react";

import { Link } from "react-router-dom";
import './signUp.css'



import React from "react";
import { register_proceed } from "../../redux/actions";
import bcrypt from "bcryptjs";
import { Form, FormGroup, FormFeedback, Input } from "reactstrap";
import Regex from "../../utilities/regex";
import { useDispatch,useSelector } from "react-redux";
import { auth } from "../../firebase";
import { toast } from "react-toastify";

const SignUp = (props) => {

    const userDetails = useSelector((state) => state.userDetails.user);
    const dispatch = useDispatch();
    const [firstName  , setFirstName ]= useState("");
    const [ lastName , setlastName ]= useState(""); 
    const [ email , setemail ]= useState(""); 
    const [ password , setpassword ]= useState(""); 
    const [ showPassword , setshowPassword ]= useState(false); 
    const [ errors , seterrors ]= useState({  firstName: false, lastName: false,  email: false,    password: false,      }); 

     const onHandleChange = ({ target: { name, value } }) => {
       
        if (name === "email") {
            seterrors({ errors: { ...errors,[name]: false, }, [name]: value.replace(/\s/g, ""), });
        } else {
            seterrors({  errors: { ...errors, [name]: false, }, [name]: value, });
        }
      };




     const handleSubmit = async (e) => {
        e.preventDefault();

    
        let encryptedpass = await bcrypt.hash(password, 10);
        if (!Regex.string(firstName.trim())) {
            seterrors( { ...errors,firstName: true,   })
        }
    
        if (!Regex.string(lastName.trim())) {
            seterrors( { ...errors,  lastName: true,  })
        }
    
        if (!Regex.email(email.trim())) {
            seterrors( { ...errors, email: true,   })
        }
    
        if (!Regex.password(password)) {
            seterrors( { ...errors, password: true,  })
        }
    
        seterrors({ errors: errors,  });
    
        if (!errors.firstname && !errors.lastname && !errors.email && !errors.password ) {
          try {
              
            const { user } = await auth.createUserWithEmailAndPassword(email,password );
           const history=props.history;
           alert(JSON.stringify(history));
            dispatch( register_proceed({user,history, data: {firstName,
                lastName,
                isDeleted: false,
                isEmailVerified: false,
                password: encryptedpass,
              },
            }));
           
            //
          } catch (error) {
            console.error(error);
            toast.error(error.message);
          }
        }
      };
    

    useEffect(()=>{
        window.scrollTo(0, 0)
    }, [])

    // useEffect(()=>{

    //     const { registrationSuccess } = props;
    //     if (props.registrationSuccess !== registrationSuccess) {
    //         // this.setState({  firstName: "",lastName: "",email: "", password: "", confirmPassword: "" });
    //         setFirstName("");
    //         setlastName("")
    //         setemail("")
    //         setpassword("")
    //         setshowPassword("")

    //       }

    // },[props])

    return (
        // <div className="col-12 wrapper main-bggrey p-0">
        //     <div className="col-12 inner-page-content login-page signUp-100 px-0 d-flex justify-content-center align-items-center ">
        //         <div id="login" className="col-sm-12  my-4">
        //             <div className="login-container col-sm-8 col-md-6 col-lg-4 col-xl-4 m-auto bg-white boxshadow border-radius8">
        //                 <div id="login-row" className="row justify-content-center align-items-center ">
        //                     <div id="login-column" className="w-100">
        //                         <h3 className="text-center page-head font-weight-bold  txtcolor">Sign Up</h3>
        //                         <h5 className="text-center txt-lghtblue page-subhead mb-4 pb-2">Enter your account details below</h5>
        //                         <div id="login-box" className="col-md-12">
        //                             <form id="login-form" className="form site-form" action="" method="post">
        //                                 <div className="form-group mb-4">
        //                                     <input type="text" name="username" id="username" className="form-control input-style min-input" placeholder="First name" />
        //                                 </div>
        //                                 <div className="form-group mb-4">
        //                                     <input type="text" name="userlname" id="userlname" className="form-control input-style min-input" placeholder="Last name" />
        //                                 </div>
        //                                 <div className="form-group mb-4">
        //                                     <input type="email" name="userlname" id="userlname" className="form-control input-style min-input" placeholder="Email address" />
        //                                 </div>
        //                                 <div className="form-group position-relative  mb-4">
        //                                     <input type="text" name="password" id="password" className="form-control input-style min-input" placeholder="Password" />
        //                                     <Link to={window.location.pathname} className="pwd-show">
        //                                         Show
        //                                     </Link>
        //                                 </div>
        //                                 <div className="form-group mb-4">

        //                                     <button type="submit" className="btn  text-white w-100 btn-custom min-input mt-2" >
        //                                         <span>
        //                                             Sign in
        //                                         </span>
        //                                     </button>
        //                                 </div>
        //                             </form>
        //                             <p className="w-100 text-center p-lght m-0">Already on Bid? <Link to="/login">Sign in</Link></p>
        //                         </div>
        //                     </div>
        //                 </div>
        //             </div>
        //         </div>
        //     </div>
        // </div>

        <div className="col-12 inner-page-content login-page px-0  login-100 d-flex justify-content-center align-items-center ">
        <div id="login" className="my-4">
          <div className="login-container col-sm-12 col-sm-8 col-md-6 col-lg-4 col-xl-4 m-auto bg-white boxshadow border-radius8">
            <div
              id="login-row"
              className="row justify-content-center align-items-center "
            >
              <div id="login-column" className="w-100">
                <h3 className="text-center page-head font-weight-bold  txtcolor">
                  Sign Up
                </h3>
                <h5 className="text-center txt-lghtblue page-subhead mb-4 pb-2">
                  Enter your account details below
                </h5>
                <div id="login-box" className="col-md-12">
                  <Form className="form site-form" onSubmit={handleSubmit}>
                    <FormGroup className="form-group mb-4">
                      <Input
                        id="firstName"
                        className="form-control input-style min-input"
                        name="firstName"
                        placeholder="First name"
                        type="text"
                        value={firstName}
                        onChange={(e)=>{
                        onHandleChange(e);
                        setFirstName(e.target.value)
                        }}
                        invalid={
                          (firstName && !Regex.string(firstName)) ||
                          errors.firstName
                        }
                      />
                      <FormFeedback id="email-err">
                        Please enter a valid first name.
                      </FormFeedback>
                    </FormGroup>
                    <FormGroup className="form-group mb-4">
                      <Input
                        id="lastName"
                        className="form-control input-style min-input"
                        name="lastName"
                        placeholder="Last name"
                        type="text"
                        value={lastName}
                        onChange={(e)=>{
                            onHandleChange(e);
                            setlastName(e.target.value)
                            }}
                        invalid={
                          (lastName && !Regex.string(lastName)) ||
                          errors.lastName
                        }
                      />
                      <FormFeedback id="email-err">
                        Please enter a valid last name.
                      </FormFeedback>
                    </FormGroup>
                    <FormGroup className="form-group mb-4">
                      <Input
                        id="email"
                        className="form-control input-style min-input"
                        name="email"
                        placeholder="Email address"
                        type="text"
                        value={email}
                        onChange={(e)=>{
                            onHandleChange(e);
                            setemail(e.target.value)
                            }}
                        invalid={(email && !Regex.email(email)) || errors.email}
                      />
                      <FormFeedback id="email-err">
                        Please enter a valid email address.
                      </FormFeedback>{" "}
                    </FormGroup>
                    {/* <div className="form-group position-relative  mb-4"> */}
                    <FormGroup className="form-group position-relative  mb-4">
                      <Input
                        id="password"
                        type={showPassword ? "type" : "password"}
                        name="password"
                        onChange={onHandleChange}
                        className="form-control input-style min-input"
                        placeholder="Password"
                        onChange={(e)=>{
                            onHandleChange(e);
                            setpassword(e.target.value)
                            }}
                        invalid={
                          (password && !Regex.password(password)) ||
                          errors.password
                        }
                      />
                      <a
                        // href="/#"
                        className="pwd-show"
                        onClick={() =>

                          setshowPassword(!showPassword )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </a>

                      <FormFeedback id="password-err">
                        Please enter a valid password with 08-16 characters long
                        and should be alphanumeric.
                      </FormFeedback>
                    </FormGroup>
                    <FormGroup className="form-group mb-4">
                      <button
                        type="submit"
                        className="btn  text-white w-100 btn-custom min-input mt-2"
                      >
                        <span>Register</span>
                      </button>
                    </FormGroup>
                  </Form>
                  <p className="w-100 text-center p-lght m-0">
                    Already on Bid?{" "}
                    <Link href="/">
                      <a>Sign in</a>
                    </Link>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default SignUp;